export default {
  inject: ['load'],
  data() {
    return {
      drugShortageCounts: [],
      notSelectedItemsCounts: [],
    };
  },
  methods: {
    getDrugShortageCountFunction: function (params) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDrugShortageCount', params).then(() => {
        if (this.$store.state.checkListModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.drugShortageCounts = this.$store.state.checkListModule.drugShortageCounts;
          if (this.$route.name == 'qcCheckListReport') {
            this.readyDrugShortageCountData(this.drugShortageCounts);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.checkListModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.checkListModule.successFlag) {
                this.getDrugShortageCountFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.checkListModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getDrugShortageCountFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getNotSelectedItemsCountFunction: function (params) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getNotSelectedItemsCount', params).then(() => {
        if (this.$store.state.checkListModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.notSelectedItemsCounts = this.$store.state.checkListModule.notSelectedItemsCounts;
          if (this.$route.name == 'qcCheckListReport') {
            this.readyNotSelectedItemsCountData(this.notSelectedItemsCounts);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.checkListModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.checkListModule.successFlag) {
                this.getNotSelectedItemsCountFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.checkListModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getNotSelectedItemsCountFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfCheckListsWithPaginationFunction: function (
      fromDate,
      toDate,
      vehicleId,
      seniorTechnicianId,
      previousSeniorTechnicianId,
      drugId,
      notSelectedCategoryItemId,
      isActive,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getListOfCheckListsWithPagination', {
          fromDate,
          toDate,
          vehicleId,
          seniorTechnicianId,
          previousSeniorTechnicianId,
          drugId,
          notSelectedCategoryItemId,
          isActive,
          pageNumber,
          pageSize,
        })
        .then(() => {
          if (this.$store.state.checkListModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            let temp = this.$store.state.checkListModule.checkLists;
            this.makeDataReady(temp);
            this.totalPages = Number(this.$store.state.checkListModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.checkListModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.checkListModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.checkListModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.checkListModule.successFlag) {
                  this.getListOfCheckListsWithPaginationFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.checkListModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfCheckListsWithPaginationFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    showError: function () {
      this.snackText = this.$store.state.checkListModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
